import { render, staticRenderFns } from "./ParametrizablePricingsSection.vue?vue&type=template&id=b282ffa2"
import script from "./ParametrizablePricingsSection.vue?vue&type=script&lang=js"
export * from "./ParametrizablePricingsSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports